document.addEventListener("turbolinks:load", function () {
    const guideSection = document.getElementById("recallGuideSection");
    if (!guideSection) return; // Only run on the recall guide page

    // Map of aria-label values to target element IDs
    const linksToHeaders = {
      "Initial Requirements": "initial_requirements",
      "Hybrid/Electronic Voting Requirement": "electronic_consent_notice",
      "Nomination Forms": "nomination_forms",
      "Pre-Ballot Notifications": "pre_ballot_notification",
      "Ballots": "ballots",
      "Results": "results"
    };

    Object.entries(linksToHeaders).forEach(([ariaLabel, targetId]) => {
      const link = document.querySelector(`a[aria-label="${ariaLabel}"]`);
      const target = document.getElementById(targetId);

      if (link && target) {
        link.addEventListener("click", function (e) {
          e.preventDefault();

          const headerOffset = 100; // adjust if your fixed header is taller
          const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        });
      }
    });
  });
